import {Routes} from "@angular/router";
import {authGuard} from "../core/auth/auth.guard";
import {ContractComponent} from "../cross/contracts/component/contract/contract.component";
import {ContractsComponent} from "../cross/contracts/component/contracts/contracts.component";
import {LayoutComponent} from "../ds/component/layout/layout.component";
import {HomePage} from "../ds/page/home-page/home.page";
import {InteractionPage} from "./page/interaction/interaction.page";
import {InteractionTypesPage} from "./page/interaction-types/interaction-types.page";
import {InteractionComponent} from "./component/interaction/interaction.component";
import {InteractionIntroComponent} from "./component/interaction-intro/interaction-intro.component";
import {InteractionFormComponent} from "./component/interaction-form/interaction-form.component";
import {InteractionScheduleComponent} from "./component/interaction-schedule/interaction-schedule.component";
import {InteractionFinalComponent} from "./component/interaction-final/interaction-final.component";


export function CiSubRoutes() : Routes {

  /**
   *
   * path:
   * Prefix of the module will always be added to the path name
   *
   *      Example
   *      path: "addresses" => route path "ad/addresses" !
   * ------------------------------------------------------------------
   *
   * component:
   * Added components need to be from type "Page"!
   * ------------------------------------------------------------------
   *
   */
  const routes: Routes = [

    {
      path: 'ci', component: LayoutComponent, canActivate: [authGuard],

      children: [
          { path: 'services', component: InteractionTypesPage  },
          { path: 'service/:typeId', component: InteractionComponent, },
          { path: 'service/:typeId/:step', component: InteractionComponent, },
          { path: 'service/:typeId/:step/:interactionId', component: InteractionComponent, },

      ]
    }


  ];
// "intro" | "form" | "schedule" | "final"
  return routes;

}
